<script setup lang="ts">
import { UseTimeAgo } from "@vueuse/components"

import { asTimestampMillis } from "~/classes/entity"
import { InterfaceSelection } from "~/classes/entity/InterfaceSelection"
import { ReactiveFile } from "~/classes/file/ReactiveFile"
import { StaticFile } from "~/classes/file/StaticFile"

const props = defineProps({
  file: null,
  event: null,
  current: { type: Boolean }
})
const { computedPublicUserInfo, isHuman } = useSavedUsers()
const { state: myself } = useSelf()

const user = computedPublicUserInfo(props.event.author)
const parent = new ReactiveFile({
  file: shallowRef(StaticFile.blank(props.event.parentId)),
  selection: InterfaceSelection.minimumFileItemSelection(),
  location: "activity",
  options: { immediate: true },
})

const parentRef = parent.ref()
if (!isHuman(props.event.author))
  throw new Error("Author invalid, not valid user")
</script>

<template>
  <div class="event">
    <user-avatar
      :size="24"
      :user
      class="event-avatar"
    />
    <!-- <div class="event-dropdown">
        <interface-inline-multi-select-dropdown
          :options="['test']"
          :label="k => k"
          :model-value="{ test: 1 }"
          left
        >
          <icon-action
            size="xs"
            type="chevron-down"
            class=""
          />
        </interface-inline-multi-select-dropdown>
      </div> -->
    <div class="event-content">
      <div class="event-title">
        <div class="event-text-secondary">
          <span v-if="myself.user?.id === event.author">You moved this file</span>
          <span v-else>Someone else moved this file</span>
          <div class="event-timestamp">
            <use-time-ago
              v-slot="{ timeAgo }"
              :time="asTimestampMillis(event.timestamp)"
            >
              {{ timeAgo }}
            </use-time-ago>
          </div>
        </div>
        <!-- <panel-activity-history-menu v-if="!current" class="event-text-dropdown" /> -->
      </div>

      <div class="event-text-main">
        <file-inline
          v-if="parentRef && !parentRef.isBlank()"
          :file="parentRef"
        />
        <div v-else class="h-[22px]" />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.event
  @apply flex gap-2 px-[#{$panel-p-default}] t-menu-sm max-w-full

.event-avatar
  @apply flex-none mt-1.25

.event-dropdown
  @apply absolute right-[#{$panel-p-default}]

.event-content
  @apply w-full flex flex-col gap-[#{$panel-activity-gap-item-content}] min-w-0

.event-title
  @apply flex items-center justify-between gap-1.5 w-full min-w-0

.event-text-secondary
  @apply w-full min-w-0 text-$global-t-default text-ellipses-inline

.event-text-dropdown
  @apply flex-none
  @apply  -mt-1 // this is because the dropdown is a bit fat

.event-text-main
  @apply flex flex-col overflow-x-hidden text-ellipses-inline text-[#$global-t-default]

.event-property-changed
  @apply space-y-0.5
.event-property-changed-type
  @apply flex gap-1 items-center text-[#{$global-t-tertiary}]
.event-property-changed-value
  @apply text-[#{$global-t-secondary}]

.event-timestamp
  @apply t-menu-xs text-$global-t-quaternary
</style>
